import React, { useCallback, useEffect, useState } from 'react';
import { apiRequest } from '../../../../../api/apiService';
import { unifarmFactory } from '../../../../../utils/contract';
import { STAKES } from '../../../../../api/queries';
import useWallet from '../../../../../hooks/useWallet';
// import { STAKES } from '../../../api/queries';
// import { unifarmFactory } from '../../../utils/contract';
// import { apiRequest } from '../../../api/apiService';
// import useWallet from '../../../hooks/useWallet';

function StakerCount({contractAddress }) {
  // const { contractAddress } = useWallet();
  // console.log("Fetched stake data:", contractAddress);
  const [stakerCount, setStakerCount] = useState(0);

  const fetchStakerCount = useCallback(async () => {
    try {
      const response = await apiRequest({
        url: unifarmFactory.rootTokens,
        method: "POST",
        data: {
          query: STAKES,
          variables: {
            where: { contract: contractAddress },
          },
        },
        auth: false,
      });

      const stakeDatas = response?.data?.stakes || [];
      // console.log("Fetched stake data:", stakeDatas);
      setStakerCount(stakeDatas.length);
    } catch (error) {
      console.error("Failed to fetch staker count:", error);
    }
  }, [contractAddress]);

  useEffect(() => {
    if (contractAddress) fetchStakerCount();
  }, [contractAddress]);

  return (
    <>
      {stakerCount}
    </>
  );
}

export default StakerCount;